<template>
  <div class="kwanzaaDetails">
    <img :src="whyImage" />
    <h4>{{whyHeader}}</h4>
    <p>{{whyDesc}}</p>
  </div>
</template>

<script>
export default {
    props:{
        whyImage: String,
        whyHeader: String,
        whyDesc: String
    }
};
</script>

<style scoped>
.kwanzaaDetails {
  padding: 50px 0px 50px 0px;
  /* height: 491px; */
  width: 364px;
  border-radius: 40px;
  background-color: #e6fbf5;
  display: grid;
  place-items: center;
}
p {
  width: 255px;
  color: #343540;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
}
img {
  height: 230px;
  /* width: 230px; */
}
h4{
  color: #343540;
  font-size: 32px;
  font-weight: 500;
  line-height: 42px;
  text-align: center;
}
</style>